import { split, forEach } from 'lodash'
/*
 * @Description: URL 处理工具类
 */
/**
 * 删除当前url中指定参数
 * @param url
 * @param key
 * @returns
 */
export function deleteQueryStringKey(url: string, key: string) {
  let str = ''
  if (url.indexOf('?') != -1) str = url.substr(url.indexOf('?') + 1)
  else return url
  let arr: string[] = []
  let returnurl = ''
  if (str.indexOf('&') != -1) {
    arr = str.split('&')
    for (const i in arr) {
      if (arr[i].split('=')[0] != key) {
        returnurl = returnurl + arr[i].split('=')[0] + '=' + arr[i].split('=')[1] + '&'
      }
    }
    return url.substr(0, url.indexOf('?')) + '?' + returnurl.substr(0, returnurl.length - 1)
  } else {
    arr = str.split('=')
    if (arr[0] == key) return url.substr(0, url.indexOf('?'))
    else return url
  }
}

export const getUrlAllParams = (url: string) => {
  // 解决乱码问题
  const res: any = {}
  const url_data = split(url, '?').length > 1 ? split(url, '?')[1] : null
  // console.log(url_data)
  if (!url_data) return null
  const params_arr = split(url_data, '&')
  forEach(params_arr, function(item) {
    const key = split(decodeURIComponent(item), '=')[0]
    const value = split(decodeURIComponent(item), '=')[1]
    res[key] = value
  })
  return res
}
